<!--  <div class="compact-card">
      <div class="card-header mb-4 flex items-center justify-between">
        <div>
          <h1 class="text-xl font-semibold">{{ 'management.infra.flatType.Table.title' | translate }}</h1>
          <p class="mt-1 text-base text-gray-500">{{ 'xxxxxxx' | translate }}</p>
        </div>
        <div>
          <button
            pButton
            icon="pi pi-plus"
            [label]="'management.infra.flatType.Table.addFlatType' | translate"
            class="p-button-primary"
            (click)="onCreateClick()"
          ></button>
        </div>
      </div>
     <app-flat-type-table></app-flat-type-table>
    


 </div> -->

<app-under-construction></app-under-construction>
